// const API_URL = "http://127.0.0.1:5000";
// const API_URL = "https://api.scanandgreet.com";
const API_URL = "https://api.emuddamaal.com";
// const API_URL = "http://192.168.1.250:9011";

export default API_URL;
